import { useCallback, useEffect, useRef, useState } from 'react';

const IDLE_HIDE_MS = 1500;

export const useIdleHideControls = (pinned: boolean) => {
  const [idle, setIdle] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const poke = useCallback(() => {
    setIdle(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => setIdle(true), IDLE_HIDE_MS);
  }, []);

  useEffect(() => {
    if (pinned) {
      setIdle(false);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    } else {
      poke();
    }
  }, [pinned, poke]);

  useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    []
  );

  return {
    controlsHidden: idle && !pinned,
    idleHandlers: {
      onMouseMove: poke,
      onMouseLeave: () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        setIdle(true);
      },
      onTouchStart: poke,
    },
  };
};
